export default {
    state: () => ({
        step: 1,
        address: "",
        siteID: null,
        coordinates: {
            latitude: null,
            longitude: null,
        },
        stations: [],
    }),
    getters: {
        getAddress: (state) => {
            return state.address;
        },
        getStep: (state) => {
            return state.step;
        },
        getSiteID: (state) => state.siteID,
        getCoordinates: (state) => state.coordinates,
    },
    mutations: {
        setStep(state, data) {
            state.step = data;
        },
        setAddress(state, data) {
            state.address = data;
        },
        setCoordinates(state, data) {
            state.coordinates = data;
        },
        setStations(state, data) {
            state.stations = data;
        },
        setSiteID(state, data) {
         state.siteID = data;
}
    },
    actions: {
        handleNextStep({commit, state}) {
            commit("setStep", state.step + 1);
        },
        updateAddress({commit}, data) {
            commit("setAddress", data);
        },
        updateCoordinates({commit}, data) {
            commit("setCoordinates", data);
        },
        updateStations({commit}, data) {
            commit("setStations", data);
        },
    },
    namespaced: true,
};
